module.exports = __webpack_public_path__ + "img/bg_police_01.76033ea1.jpg";